// extracted by mini-css-extract-plugin
export default {"logo":"giveaway-info-page__logo___oFBBP"};